<template lang="pug">
  div.calculation.regional-tariff-update-first
    e-form-modal(
    ref="modalForm"
    @submitModalForm="sendForm()"
    @deleteItem="() => {}"
    :hideDeleteButton="false"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title
          template Расчет Единого тарифа на услугу Регионального оператора на 1-ый год действия Соглашения
        e-steps(
          :steps="regionalTariffSteps"
        )
      slot
        e-form(:formValidator="formValidator")
          div.body.title-body
            div.col
              div.col-block
                label 1. Величина собственных расходов Регионального оператора должна быть определена в конкурсной заявке РО

          div.body
            div.col
              div.col-block
                e-form-group(
                name="own_expenses"
                inputType="input"
                label="Собственные расходы РО"
                :model="fields"
                :required="true"
                tabView="tab1"
                validationRule="double"
                )

          div.body.title-body
            div.col
              div.col-block
                label 2. Объем (масса) отходов, сбор и транспортирование которых будет осуществлять региональный оператор в 1-ый год действия Соглашения, должен быть определен в составе конкурсной документации

          div.body
            div.col
              div.col-block
                e-form-group(
                name="v_waste"
                inputType="input"
                label="V отходов (в куб. м.)"
                :model="fields"
                tabView="tab1"
                validationRule="double"
                :required="true"
                )
                  div(slot="footer").auto-calc
                   button(
                     title="Рассчитать значение"
                     @click.stop.prevent="recalcMVRatio('v_waste')"
                   ).actions-panel__button.btn-calc
            div.col
              div.col-block
                e-form-group(
                name="m_waste"
                inputType="input"
                label="M отходов (в тоннах)"
                :model="fields"
                tabView="tab1"
                validationRule="double"
                :required="true"
                )
                  div(slot="footer").auto-calc
                    button(
                    title="Рассчитать значение"
                    @click.stop.prevent="recalcMVRatio('m_waste')"
                    ).actions-panel__button.btn-calc
            div.col
              div.col-block
                e-form-group(
                name="m_to_v_convert_ratio"
                inputType="input"
                label="Коэффициент перевода объема в массу"
                :model="fields"
                tabView="tab1"
                validationRule="double"
                :required="true"
                )
                  div(slot="footer").auto-calc
                    button(
                    title="Рассчитать значение"
                    @click.stop.prevent="recalcMVRatio('m_to_v_convert_ratio')"
                    ).actions-panel__button.btn-calc

          div.body.title-body
            div.col
              div.col-block
                label 3. Величина тарифов, надбавок к тарифам, объем (масса) отходов, направляемых на обезвреживание и захоронение на объекты операторов должна быть определена в составе конкурсной документации
                span(v-if="tableErrors.tariffs").error {{tableErrors.tariffs}}

          div.body
            div.col
              e-button-add(@click="addNewRowToTable('tariffs')")

          div.body
            div.col
              e-table-editable(
              :tableInOnlineMode="null"
              :enableOnAdd="enableOnAdd"
              :attributes="tariffsAttributes"
              ref="tariffs"
              :dataUrl="tariffsDataUrl"
              :postUrl="() => null"
              :patchUrl="() => null"
              :deleteUrl="() => null"
              :tableHeight="'200'"
              :tableHeightRight="'200'"
              :fewRowsCount="2"
              :defaultColumnWidth="80"
              )

</template>

<script>
  import {mongoApi} from '../../api/api-endpoints.js'
  import {CalculationRegionalTariffs} from '../../config/mongo'
  import regionalTariffFirstForm from './mixins/regional-tariff-first-form'

  export default {
    mixins: [regionalTariffFirstForm],
    data () {
      return {
        tabView: 'tab1',
        fields: {
          own_expenses: '',
          m_to_v_convert_ratio: '',
          v_waste: '',
          m_waste: '',
          tariff_result: 0,
          tariff_result_volume: 0
        }
      }
    },
    methods: {
      onSuccess (response, afterSaveResponse) {
        this.onSuccessSaveCalculation(response, afterSaveResponse)
      },
      getUpdateOrCreateUrl () {
        return mongoApi.updateCollectionItem(CalculationRegionalTariffs, this.$route.params.id)
      },
      getItemEndpoint (route) {
        return mongoApi.getCollectionItem(CalculationRegionalTariffs, route.params.id)
      },
      getDeleteUrl (id) {
        return null
      },
      getItemsEndpoint (route, fromRoute) {
        return mongoApi.getCollectionItems(CalculationRegionalTariffs, {
          query: {
            'filter[operator_id]': route.query['filter[operator_id]']
          }
        })
      }
    }
  }
</script>
